import numbro from "numbro";
import options from "@/data/options.js";

const removeChar = (str, target) => {
  const re = new RegExp(target, "g");
  return str.replace(re, "");
};

export default {
  humanizeAnnualRevenue(value) {
    const lookup = {
      "00000_00001": "under $1m",
      "00001_00005": "$1m - $5m",
      "00005_00010": "$5m - $10m",
      "00010_00025": "$10m - $25m",
      "00025_00100": "$25m - $100m",
      "00100_00500": "$100m - $500m",
      "00500_99999": "$500m+",
    };
    return lookup[value] || "";
  },
  humanizeNexus(value) {
    const found = options.nexusOptions.find((item) => item.value === value);
    return found ? found.name : value;
  },
  humanizeAdvisor(value) {
    const found = options.advisoryOptions.find((item) => item.value === value);
    return found ? found.label : value;
  },
  humanizeTransactionRole(value) {
    const found = options.transactionRoles.find((item) => item.value === value);
    return found ? found.name : value;
  },
  humanizeInvestmentType(value) {
    const found = options.dealStructure.find((item) => item.value === value);
    return found ? found.name : value;
  },
  humanizeRaiseHistory(value) {
    const found = options.raiseHistoryOptions.find(
      (item) => item.value === value
    );
    return found ? found.label : value;
  },
  convertToYearCurrency(value) {
    const currentYear = new Date().getFullYear();
    return `USD ${value} (${currentYear})`;
  },
  getValueFromYearCurrency(line) {
    if (!line) {
      return "";
    }
    if (typeof line !== String) {
      return line;
    }
    const parts = line.trim().split(" ");
    if (parts.length === 3) {
      const amount = removeChar(parts[1], ",");
      return amount;
    }
    return "";
  },
  formatToShortCurrency(data, currency = "US$") {
    if (!data) {
      return;
    }
    return (
      currency +
      " " +
      numbro(data)
        .format({
          trimMantissa: true,
          mantissa: 0,
          average: true,
        })
        .toUpperCase()
    );
  },
  humanizeDebtType(value) {
    const lookup = {
      ppp: "Private Public Partnership",
      financialInstitution: "Financial Institution",
      fdi: "Foreign Direct Investment (FDI)",
      jointVenture: "Joint Venture",
    };
    return lookup[value] || value;
  },
};
